import { render } from "./ProductSubone.vue?vue&type=template&id=49547ad0&scoped=true"
import script from "./ProductSubone.vue?vue&type=script&lang=js"
export * from "./ProductSubone.vue?vue&type=script&lang=js"

import "./ProductSubone.vue?vue&type=style&index=0&id=49547ad0&scoped=true&lang=css"
import "./ProductSubone.vue?vue&type=style&index=1&id=49547ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49547ad0"]])

export default __exports__